export const getSectionFullCode = (code, survey) => {
  if (!code || !survey?.year || !survey?.type || !survey?.subType) {
    return code;
  }

  const codeParts = code.split('#');
  if (codeParts.length === 4) {
    return code;
  }

  return `${code}#${survey.year}#${survey.type.toUpperCase()}#${survey.subType.toUpperCase()}`;
};

export const prepareSectionMetadata = (metadata, oldMetadata, survey) => {
  if (survey?.type && survey?.subType && survey?.year) {
    const overrideCode = `${
      survey.year
    }#${survey.type.toUpperCase()}#${survey.subType.toUpperCase()}`;
    const newSectionMetadata = {
      ...oldMetadata,
      overrides: {
        ...oldMetadata?.overrides,
        [overrideCode]: {
          ...oldMetadata?.overrides?.[overrideCode],
        },
      },
      name: metadata?.name,
      code: getSectionFullCode(metadata?.code, survey),
    };

    return newSectionMetadata;
  }

  return metadata;
};

export const getSectionNameByCodeAndSurvey = (code, survey, sections = []) => {
  if (!code) return '';

  const sectionIdentifier = String(code);

  const hasSurveyInfo = survey && survey.year && survey.type && survey.subType;

  // Build full section code: "001#2025#BUF#ASLP"
  const fullSectionCode = hasSurveyInfo
    ? `${sectionIdentifier}#${survey.year}#${String(survey.type).toUpperCase()}#${String(
        survey.subType
      ).toUpperCase()}`
    : null;

  const findByCode = (candidateCode) =>
    sections.find(
      (s) =>
        s?.Data?.code && candidateCode && s.Data.code.toLowerCase() === candidateCode.toLowerCase()
    );

  let section = null;

  // Try to find section by full section code
  if (fullSectionCode) {
    section = findByCode(fullSectionCode);
  }

  // If not found, try simple identifier (e.g. "001")
  if (!section) {
    section = findByCode(sectionIdentifier);
  }

  // If not found, fallback to the identifier itself
  return section?.Data?.name || sectionIdentifier;
};
